import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useNavigate } from 'react-router-dom'
import ClipPathBorderRadius from "../../components/ClipPathBorderRadius";
import { getCards, getSaleCards } from '@/api/url.js'
import Mine from "./Mine";
import { useDispatch, useSelector } from "react-redux";
import Sale from "../cards/Sale"
import BScroll from 'better-scroll'
import "./index.less"
import { changeCardData, changeSaleCardData } from "../../store/module/tasks";
import usePlaySound from "@/hook/usePlaySound.tsx"

import { List } from 'react-vant';
import { changeActive } from "../../store/module/search";
import Back from "../../components/common/BackComp";
import { useTranslation } from "react-i18next";

new BScroll('.changeBackground-box', {
    pullUpLoad: true,
    scrollbar: true,
    pullDownRefresh: true
    // and so on
})

const pageSize = 10;

const changeBackground = () => {
    const { t } = useTranslation();
    const navigator = useNavigate();
    const dispatch = useDispatch()
    const currCharacterInfo = useSelector((state: any) => state.progress.currCharacterInfo)
    // const [saleCardsData, setSaleCardsData] = useState<any>(useSelector((state: any) => state.tasks.resSale))
    const [saleCardsData, setSaleCardsData] = useState<any>([])
    const [buttonActive, setButtonActive] = useState(1);
    const [finished, setFinished] = useState(false);
    // const [isLoading, setIsLoading] = useState(false)
    const isLoading = useRef(false)
    // const [isInitLoading, setIsInitLoading] = useState(true)
    const isInitLoading = useRef(true)

    const currPage = useRef(1)
    const total = useRef(0);
    const getCardsData = useCallback(async () => {

        // console.log(isLoading.current)
        if (isLoading.current) { return false }

        await getDataList()
    }, [])

    useEffect(() => {
        setSaleCardsData([])

        isInitLoading.current = true
        setFinished(false)
        currPage.current = 1;
    }, [buttonActive])

    const getDataList = async () => {

        isLoading.current = true
        try {

            const { code, data: { data, count } } = await getSaleCards(currPage.current, pageSize)
            if (code === '0') {
                setSaleCardsData((prevData: any) => [...prevData, ...data]);
                // setTotal(count)
                total.current = count;
                // setIsLoading(false)
                isLoading.current = false
                // setIsInitLoading(false)
                isInitLoading.current = false
                if (data.length == 0) {
                    setFinished(true)
                }
            } else {
                setFinished(true)
                total.current = 0
            }

        } catch (e) {
            console.log(e)
            // setIsLoading(false)
            isLoading.current = false
            setFinished(true)
            total.current = 0
        }

        if (currPage.current * pageSize >= total.current) {
            setFinished(true)
            // return false;
        }




    }

    const onLoad = async () => {
        if (finished || isInitLoading.current) return;
        currPage.current++
        await getDataList()
    }
    const goToTalk = () => {
        sessionStorage.setItem("isSendMessage", "1")
        navigator("/agent")
    }

    // ------------------------ 滑动 -----------------------
    useLayoutEffect(() => {
        document.addEventListener('touchstart', touchStartHandle);
        return () => {
            document.removeEventListener('touchstart', touchStartHandle);
            // window.scrollTo(0, 0);
        }

    })

    const touchStartHandle = useCallback(() => {
        window.scrollTo(0, 1);
        ensureDocumentIsScrollable();
    }, [])

    const ensureDocumentIsScrollable = () => {
        const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
        if (!isScrollable) {
            document.documentElement.style.setProperty(
                "height",
                "calc(100vh + 0.5px)",
                "important"
            );
        }
    }

    return (
        <div className={`${buttonActive == 1 ? '' : 'changeBackground-box'} w-full h-full overflow-auto text-white bg-no-repeat bg-cover bg-center relative pt-14 pb-5`} style={{ backgroundImage: `url(${currCharacterInfo.bg_image})` }}>
            <div className="nav-box md:absolute max-md:fixed top-0 left-0 w-full h-[134px] z-[999] pt-4 px-4 box-border bg-gradient-to-b from-[#000000] to-[#fff]/[0]">
                <div className="back h-[44px] w-full relative flex justify-center items-center">
                    <Back title={currCharacterInfo.name} callback={() => { goToTalk() }}></Back>
                </div>
                <div className="toggle h-[74px] flex items-center justify-center">
                    <div className="h-[44px] bg-[#000]/50 rounded-full w-[80%] grid grid-cols-2 gap-0 justify-center items-center">
                        <ClipPathBorderRadius setButtonActive={() => setButtonActive(1)} buttonActive={buttonActive} borderRadius={22} height={44} width={125} flag={1} text={t("ai.mine")}></ClipPathBorderRadius>
                        <ClipPathBorderRadius setButtonActive={() => { setSaleCardsData([]); isInitLoading.current = true; setButtonActive(2); currPage.current = 1 }} getCardsData={getCardsData} loading={isInitLoading.current && isLoading.current} Refresh={true} buttonActive={buttonActive} borderRadius={22} height={44} width={125} flag={2} text={`${t("card.index.sale")} ${total.current ? total.current : ""}`} ></ClipPathBorderRadius>
                    </div>

                </div>
            </div>

            <>
                {buttonActive == 1 && <Mine id={currCharacterInfo.id}></Mine>}
                {
                    buttonActive == 2 &&
                    <List className="pt-8" finished={finished} loading={isLoading.current} immediateCheck={false} onLoad={onLoad} loadingText={t("other.loading")}>
                        {
                            saleCardsData.length ? <Sale saleCardsData={saleCardsData} setSaleCardsData={setSaleCardsData}></Sale> : null
                        }
                    </List>
                }
            </>
        </div>
    )
}

export default changeBackground;